<script setup>
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { computed } from '@vue/reactivity'
import GroupRankItem from './components/GroupRankItem.vue'
import { formatDuringNoDecimal } from '@/utils/tools'
import {
  useFirstRank,
  usePersonRank,
  useGroupRank,
  useGroupShowConfig,
} from './composable/index'
import { getGroupRank } from '@/api/rank'
import { Loading, Button, Dialog } from 'vant'

const activeName = ref('a')
const sublevel = ref('')

const store = useStore()

// 是否显示个人排行
const showPersonRank = computed(() => {
  return store.getters.getRankConfig?.rankPerson === 2
})
// 是否显示单位排行
const showGroupRank = computed(() => {
  return store.getters.getRankConfig?.rankGroup === 2
})
// 个人显示姓名类型
const showRealName = computed(() => {
  return store.getters.getRankConfig?.rankName === 2
})

// 是否显示团体参与人数 是否显示团体参与次数是否显示团体分数
const { showGroupPeronCount, showGroupCount, showGroupScore } =
  useGroupShowConfig()

// 个人一级排行
const { firstRankList, fetchPersonFirstRank } = useFirstRank()

// 个人排行
const {
  personRankList,
  fetchPersonRank,
  personFinished,
  personLoading,
  personSublevel,
} = usePersonRank()

// 单位排行
const {
  groupRankList,
  groupFirstList,
  fetchGroupRank,
  groupLoading,
  groupFinished,
  groupSublevel,
} = useGroupRank()

const wrapLoading = ref(false)

const imgError = (event) => {
  let img = event.srcElement
  img.src = require('../../assets/img/person/rank-touxiang2.png')
  img.onerror = null //防止闪图
}

watch(
  activeName,
  async (n, o) => {
    if (n === o) return

    if (n === 'a') {
      fetchPersonFirstRank()
      // fetchPersonRank()
    } else {
      // fetchGroupRank()
    }
  },
  {
    immediate: true,
  }
)
// 个人一级
const handleFirstPersonChange = async (name) => {
  personSublevel.value = name

  await fetchPersonRank({
    firstId: personSublevel.value,
    refresh: true,
  })
}

// 团体点开二级
const handleSFisrtGroupChange = (id) => {
  fetchGroupRank({
    firstId: id,
  })
}

const loading = ref(false)
const finished = ref(true)

const handleGroupClick = (firstId) => {
  groupSublevel.value = firstId
  fetchGroupRank({
    firstId: firstId,
    refresh: true,
  })
}

loading.value = false
</script>

<template>
  <Loading
    v-if="wrapLoading"
    class="center"
    type="spinner"
    color="#2faeff"
    vertical
    >加载中...</Loading
  >
  <div v-else class="bg">
    <div class="title">
      <p class="explain">
        {{
          $store.getters.getRankConfig?.content == '00'
            ? ''
            : $store.getters.getRankConfig?.content
        }}
      </p>
    </div>
    <div class="content">
      <van-tabs
        v-if="showPersonRank && showGroupRank"
        v-model:active="activeName"
        color="#0389FB"
        sticky
      >
        <van-tab
          v-if="showPersonRank"
          class="personal"
          name="a"
          title="个人排行"
        >
          <van-tabs
            class="van-tab2"
            :class="$store.getters.getRankConfig?.personLevel === 2 && 'hide'"
            v-model:active="sublevel"
            sticky
            @change="handleFirstPersonChange"
          >
            <van-tab
              v-for="(item, index) in firstRankList"
              :title="item.name"
              :name="item.id"
              :key="item.id"
            ></van-tab>
          </van-tabs>
        </van-tab>

        <van-tab
          v-if="showGroupRank"
          class="company"
          name="b"
          :title="`${store.state.moduleInfo?.typeName || ''}排行`"
        >
        </van-tab>
      </van-tabs>
      <div v-if="showPersonRank && activeName === 'a'" class="personal">
        <div class="personal-title" sticky>
          <div class="personal-title-item1">排名</div>
          <div class="personal-title-item2">用户</div>
          <div class="personal-title-item3">时间</div>
          <div class="personal-title-item4">
            {{
              $store.getters.getRankConfig?.rankBase === 1
                ? '总得分'
                : $store.getters.getRankConfig?.rankBase === 2
                ? '平均分'
                : '最高分'
            }}
          </div>
        </div>

        <div
          v-if="personRankList.length == 0 && !personLoading"
          class="default"
        >
          <span>暂无排行榜</span>
        </div>

        <van-list
          v-model:loading="personLoading"
          @load="fetchPersonRank"
          :finished="personFinished"
          finished-text="没有更多了"
        >
          <div v-for="(item, index) in personRankList" :key="item" class="item">
            <div class="item-child1">
              <img
                v-if="index + 1 == 1"
                mode="scaleToFill"
                src="../../assets/img/person/icon-rank1.png"
              />
              <img
                v-if="index + 1 == 2"
                mode="scaleToFill"
                src="../../assets/img/person/icon-rank2.png"
              />
              <img
                v-if="index + 1 == 3"
                mode="scaleToFill"
                src="../../assets/img/person/icon-rank3.png"
              />
              <div v-if="index + 1 > 3">{{ index + 1 }}</div>
            </div>
            <div class="item-child2">
              <img
                class="item-child2-item1"
                alt=""
                :src="
                  item.headImg || '../../assets/img/person/rank-touxiang.png'
                "
                @error="imgError"
              />
              <div class="item-child2-item2">
                <div class="item-child2-item21 van-ellipsis">
                  {{ showRealName ? item.name : item.nickName }}
                </div>
                <div class="item-child2-item22 van-ellipsis">
                  {{
                    (item.firstName || '') +
                    (item.secondName || '') +
                    (item.thirdName || '')
                  }}
                </div>
              </div>
            </div>
            <div class="item-child3">
              {{
                formatDuringNoDecimal(item.totalTime) == 0
                  ? '--'
                  : formatDuringNoDecimal(item.totalTime)
              }}
            </div>
            <div class="item-child4">
              {{
                $store?.getters.getRankConfig?.rankBase === 1
                  ? item?.totalScore || '--'
                  : $store.getters.getRankConfig?.rankBase === 2
                  ? item?.avgScore?.toFixed(2) || '--'
                  : item?.maxScore || '--'
              }}
            </div>
          </div>
        </van-list>
      </div>
      <div v-if="showGroupRank && activeName === 'b'" class="company">
        <div class="sublevel-title">
          <div class="sublevel-title-item1">排名</div>
          <div class="sublevel-title-item2">
            {{ store.state.moduleInfo?.typeName }}
          </div>
          <div v-if="showGroupPeronCount" class="sublevel-title-item4">
            参与人数
          </div>
          <div v-if="showGroupCount" class="sublevel-title-item4">参与次数</div>
          <div v-if="showGroupScore" class="sublevel-title-item4">分数</div>
        </div>

        <div v-if="groupRankList.length == 0 && !groupLoading" class="default">
          <span>暂无排行榜</span>
        </div>

        <van-list
          v-model:loading="groupLoading"
          :finished="groupFinished"
          @load="fetchGroupRank"
          finished-text="没有更多了"
        >
          <div
            v-for="(item, index) in groupRankList"
            :key="item"
            class="item-wrap"
          >
            <GroupRankItem
              :index="index"
              :item="item"
              @groupFirstClick="handleGroupClick"
            />
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<style>
.arrowTransform {
  transition: 0.2s;
  transform-origin: center;
  transform: rotateZ(180deg);
}

.arrowTransformReturn {
  transition: 0.2s;
  transform-origin: center;
  transform: rotateZ(0deg);
}

.arrowTransformReturn svg path {
  fill: red;
}

.van-tabs--line .van-tabs__wrap {
  height: 1.5rem;
}

.van-tabs__line {
  width: 1.4rem;
  height: 0.1rem;
}

.van-tab {
  line-height: 0.6rem;
}

.van-tab--active {
  color: #0389fb;
}

.van-tab__text {
  font-size: 0.6rem;
}

.van-tab2 .van-tab__text {
  font-size: 0.49rem;
}

.van-tab2 .van-tab {
  border-radius: 0.1rem;
  line-height: 0.49rem;
  background: rgba(230, 230, 230, 0.5);
  margin: 0 0.12rem;
}

.personal .van-tabs__wrap {
  height: 1rem;
}

.personal .van-tabs__line {
  display: none;
}

.personal .van-tab--active {
  border-radius: 0.1rem;
  background-color: #0389fb;
  color: #ffffff;
}

.hide .van-sticky {
  display: none;
}
</style>
<style lang="scss" scoped>
.center {
  margin: 50% auto 0;
  text-align: center;
}
.bg {
  height: 100vh;
  background-color: #ffffff;

  .title {
    width: 100%;
    height: 436px;
    background-image: url('../../assets/img/person/rank-title.png');
    background-size: 100% 100%;

    .explain {
      width: 362px;
      font-size: 26px;
      line-height: 37px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      padding: 180px 0 0 45px;
    }
  }

  .content {
    padding: 10px 20px 20px 20px;
    position: relative;
    top: -110px;
    background-color: #fff;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;

    .tips {
      margin: 10px 0;
      font-size: 32px;
      text-align: center;
      color: #777777;
    }

    // 个人排行
    .personal {
      margin-top: 20px;

      .personal-title {
        margin: 30px 0;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
        display: flex;

        .personal-title-item1 {
          width: 100px;
          margin-left: 15px;
        }
        .personal-title-item2 {
          width: 100px;
          margin-left: 80px;
        }
        .personal-title-item3 {
          width: 150px;
          margin-left: 130px;
          text-align: center;
        }
        .personal-title-item4 {
          width: 105px;
          margin-left: 30px;
        }
      }

      .item {
        height: 75px;
        display: flex;
        align-items: center;
        margin-bottom: 28px;

        .item-child1 {
          width: 80px;
          font-size: 30px;
          text-align: center;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;

          img {
            width: 47px;
            height: 34px;
          }
        }

        .item-child2 {
          width: 315px;
          display: flex;
          padding-left: 15px;

          .item-child2-item1 {
            width: 75px;
            height: 75px;
            object-fit: fill;
            border-radius: 50%;
          }

          .item-child2-item2 {
            margin-left: 22px;

            .item-child2-item21 {
              margin-top: 6px;
              width: 200px;
              height: 31px;
              font-size: 32px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .item-child2-item22 {
              margin-top: 5px;
              width: 200px;
              height: 23px;
              font-size: 24px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
            }
          }
        }

        .item-child3 {
          width: 150px;
          text-align: center;
          font-family: PingFang SC;
          font-weight: 400;
          color: #555555;
          font-size: 27px;
          margin-left: 15px;
        }

        .item-child4 {
          width: 105px;
          text-align: center;
          margin-left: 18px;
          font-size: 32px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #018af9;
        }
      }
    }

    // 团体排行
    .company {
      .sublevel-title {
        margin: 30px 0;
        display: flex;
        font-size: 28px;
        font-weight: 400;
        color: #999999;

        .sublevel-title-item1 {
          width: 100px;
          text-align: center;
        }

        .sublevel-title-item2 {
          flex: 1;
          text-align: left;
          margin-left: 40px;
        }

        .sublevel-title-item3 {
          /* margin-left: 33px; */
        }

        .sublevel-title-item4 {
          width: 140px;
          text-align: center;
        }
      }
    }
  }
}

.default {
  width: 450px;
  height: 350px;
  background-image: url('../../assets/img/person/rank-zanwu.png');
  background-size: 100% 100%;
  margin: 100px auto 0;
  text-align: center;

  span {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    position: absolute;
    left: 0;
    right: 0;
    bottom: -30px;
  }
}
</style>
